import React from "react";
import { Modal, Button, Form } from "antd";
import VideoUploadInput from "./VideoUploadInput";
import VideoPreview from "./VideoPreview";
import ExerciseFormFields from "./ExerciseFormFields";
import dayjs from "dayjs";
const UploadExerciseModal = ({
  visible,
  onCancel,
  onSubmit,
  form,
  uploadValues,
  setUploadValues,
  uploadProps,
  dummyRequest,
  token,
  getYouTubeEmbedUrl,
  isMobile,
}) => {
  return (
    <Modal
      title="Prescribe Exercise"
      open={visible}
      onCancel={onCancel}
      centered
      destroyOnClose 
      width={isMobile ? "92%" : 600}
      bodyStyle={
        isMobile
          ? {
              maxHeight: "75vh",
              overflowY: "auto",
              padding: "12px 16px",
            }
          : {}
      }
      footer={[
        <div
          key="footer"
          style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "8px" : "12px",
            justifyContent: "flex-end",
          }}
        >
          <Button
            type="primary"
            block={isMobile}
            onClick={() => onSubmit(false)}
          >
            Submit and Add Another
          </Button>
          <Button
            type="primary"
            block={isMobile}
            onClick={() => onSubmit(true)}
          >
            Submit and Close
          </Button>
        </div>,
      ]}
    >
      <Form form={form} layout="vertical" initialValues={{
    startDate: dayjs(), 
  }}>
        <VideoUploadInput
          uploadValues={uploadValues}
          setUploadValues={setUploadValues}
          uploadProps={uploadProps}
          dummyRequest={dummyRequest}
          token={token}
        />

        <VideoPreview
          videoPreviewURL={uploadValues.videoPreviewURL}
          isLink={uploadValues.isLink}
          getYouTubeEmbedUrl={getYouTubeEmbedUrl}
        />

        <ExerciseFormFields />
      </Form>
    </Modal>
  );
};


export default UploadExerciseModal;
